import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchstores, creatstore } from '../../services/api';

// GET /store/fetch (paginated list used by Store.jsx)
export const fetchStoresList = createAsyncThunk(
    'store/fetchStoresList',
    async ({ perPage, page, keyword = null }, { rejectWithValue }) => {
        try {
            const response = await fetchstores(perPage, page, keyword);
            return response.data; // { data, current_page, last_page, ... }
        } catch (error) {
            return rejectWithValue(error?.message || 'Failed to fetch stores');
        }
    }
);

// POST /store/create (used by AddStore.jsx for both create + edit — edit sends `id`)
export const saveStore = createAsyncThunk(
    'store/saveStore',
    async (formDataToSend, { rejectWithValue }) => {
        try {
            const response = await creatstore(formDataToSend);

            if (!response?.status?.success) {
                return rejectWithValue(response);
            }

            return response;
        } catch (error) {
            // Preserve complete API error response
            return rejectWithValue(
                error?.response?.data || {
                    message: error?.message || 'Failed to save store',
                }
            );
        }
    }
);

const initialState = {
    list: [],
    currentPage: 1,
    totalPages: 1,
    loading: false,
    saving: false,
    error: null,
};

const storeSlice = createSlice({
    name: 'store',
    initialState,
    reducers: {
        resetStoreError(state) {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStoresList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStoresList.fulfilled, (state, action) => {
                state.loading = false;
                const payload = action.payload;
                state.list = payload?.data || payload || [];
                state.currentPage = payload?.current_page || 1;
                state.totalPages = payload?.last_page || 1;
            })
            .addCase(fetchStoresList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch stores';
            })
            .addCase(saveStore.pending, (state) => {
                state.saving = true;
                state.error = null;
            })
            .addCase(saveStore.fulfilled, (state) => {
                state.saving = false;
            })
            .addCase(saveStore.rejected, (state, action) => {
                state.saving = false;
                state.error = action.payload || 'Failed to save store';
            });
    },
});

export const { resetStoreError } = storeSlice.actions;
export default storeSlice.reducer;